<template>
  <page>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="newMode">mdi-plus</v-icon>
        <v-icon v-else>mdi-pencil</v-icon>
        <v-toolbar-title v-if="newMode">Create Payment Letter Details</v-toolbar-title>
        <v-toolbar-title v-else-if="reviewMode">Edit Payment Letter Details</v-toolbar-title>
        <v-toolbar-title v-else-if="queryMode">Review Payment Letter Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6 v-if="newMode">
              <v-autocomplete
                :items="bankAbbrev"
                v-model="forms.bankRef"
                :label="labels.bankRef"
                item-text="label"
                item-value="value"
                :error-messages="errors.collect('bankRef')"
                data-vv-name="forms.bankRef"
                :data-vv-as="labels.bankRef"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.bankRef }}</v-subheader>
              <div class="queryValue" v-for="item in filterBankRefList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xl3 lg6 xs6 v-if="newMode">
              <v-autocomplete
                :items="paytMeth"
                v-model="forms.paytMeth"
                :label="labels.paytMeth"
                item-text="label"
                item-value="value"
                :error-messages="errors.collect('paytMeth')"
                data-vv-name="forms.paytMeth"
                :data-vv-as="labels.paytMeth"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.paytMeth }}</v-subheader>
              <div class="queryValue" v-for="item in filterPaytMethList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xl3 lg6 xs6 v-if="newMode">
              <v-text-field
                v-model="forms.paytStat"
                :label="labels.paytStat"
                :error-messages="errors.collect('paytStat')"
                data-vv-name="paytStat"
                :data-vv-as="labels.paytStat"
                v-validate="'required|max:4'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.paytStat }}</v-subheader>
              <div class="queryValue">{{ forms.paytStat }}</div>
            </v-flex>
            <v-flex xl3 lg6 xs6 v-if="!queryMode">
              <v-text-field
                v-model="forms.paytStatDesc"
                :label="labels.paytStatDesc"
                :error-messages="errors.collect('paytStatDesc')"
                data-vv-name="paytStatDesc"
                :data-vv-as="labels.paytStat"
                v-validate="'required|max:35'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.paytStatDesc }}</v-subheader>
              <div class="queryValue">{{ forms.paytStatDesc }}</div>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="forms.apprvRejLtr"
                :readonly="queryMode"
                :label="labels.apprvRejLtr"
                no-resize
                rows="10"
                :error-messages="errors.collect('apprvRejLtr')"
                data-vv-name="apprvRejLtr"
                :data-vv-as="labels.apprvRejLtr"
                :maxlength="4000"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ forms.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ forms.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="!newMode">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ forms.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ forms.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" dark class=" mr-2" @click="doCancel" :loading="submitting">
          Cancel
          <v-icon right>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" v-if="newMode || reviewMode" dark class=" mr-2" @click="doSave" :loading="submitting">
          Save
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        bankRef: 'Bank Reference',
        paytMeth: 'Payment Method',
        paytStat: 'Payment Status',
        paytStatDesc: 'Payment Status Description',
        apprvRejLtr: 'Letter Text',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      forms: {
        bankRef: '',
        paytMeth: 'P',
        paytStat: '',
        paytStatDesc: '',
        apprvRejLtr: '',
        createdBy: '',
        createdDate: '',
        modifiedBy: '',
        modifiedDate: ''
      },
      newMode: false,
      reviewMode: false,
      queryMode: false,
      bankAbbrev: [],
      paytMeth: [],
      submitting: false
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('bankAbbrev')
      this.getCommonDataList('paytMeth')
    },
    doFetchData() {
      this.resetValidator()
      this.resetMessages()
      this.newCoverLetter = false
      const expand = {
        bankRef: this.paytStatLtr.bankRef,
        paytMeth: this.paytStatLtr.paytMeth,
        paytStat: this.paytStatLtr.paytStat
      }
      const apiURI = this.menu.getPaytStatLtr
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.forms.bankRef = data.paytStatLtr.bankRef
              this.forms.paytMeth = data.paytStatLtr.paytMeth
              this.forms.paytStat = data.paytStatLtr.paytStat
              this.forms.paytStatDesc = data.paytStatLtr.paytStatDesc
              this.forms.apprvRejLtr = data.paytStatLtr.apprvRejLtr
              this.forms.createdBy = data.createdBy
              this.forms.createdDate = data.createdDate
              this.forms.modifiedBy = data.modifiedBy
              this.forms.modifiedDate = data.modifiedDate
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCancel() {
      this.$router.push({ name: 'paytStatLtr' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPaytStatLtr
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.forms)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doUpdate() {
      const apiURI = this.menu.updatePaytStatLtr
      if (apiURI) {
        this.$http
          .put(apiURI, this.forms)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doCancel()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  created() {
    if (this.paytStatLtr.tranMode === 'new') {
      this.newMode = true
      this.forms.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.forms.createdDate = new Date()
    } else if (this.paytStatLtr.tranMode === 'review') {
      this.doFetchData()
      this.reviewMode = true
    }
    if (this.paytStatLtr.tranMode === 'query') {
      this.doFetchData()
      this.queryMode = true
    }
    this.doInit()
  },
  computed: {
    paytStatLtr() {
      return this.$store.state.coverLetterParam.paytStatLtr
    },
    menu() {
      return this.$store.state.coverLetterParam.menu
    },
    filterBankRefList() {
      return this.bankAbbrev.filter((list) => {
        return list.value === this.forms.bankRef
      })
    },
    filterPaytMethList() {
      return this.paytMeth.filter((list) => {
        return list.value === this.forms.paytMeth
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
